import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';
import { USERS_KEY } from './useUsers.js';

// `errorToast=false` تعطّل toast الخطأ التلقائي حتى تتولى الواجهة عرض الأخطاء
// تحت الحقول مباشرةً (UserDrawer يستخدم هذا الخيار).
export function useCreateUser({ errorToast = true } = {}) {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/users', body).then((r) => r.data),
    successMessage: 'تم إنشاء المستخدم',
    errorToast,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: USERS_KEY });
    }
  });
}

export function useUpdateUser({ errorToast = true } = {}) {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/users/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ التعديلات',
    errorToast,
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: USERS_KEY });
      const id = variables?.id;
      if (id) qc.invalidateQueries({ queryKey: ['users', id, 'permissions'] });
    }
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/users/${id}`).then((r) => r.data),
    successMessage: 'تم حذف المستخدم',
    onSuccess: () => qc.invalidateQueries({ queryKey: USERS_KEY })
  });
}

export function useResetPassword() {
  return useApiMutation({
    mutationFn: (id) => api.post(`/users/${id}/reset-password`).then((r) => r.data),
    errorToast: true
  });
}
